import Vue from 'vue'
import Vuex from 'vuex'
import multilevel2 from 'multilevel2-http/lib/client'
import Chance from 'chance'

import sublevel from '@/services/SubLevelAdapterService'
import ApplicationException from '@/errors/ApplicationException'

import UserModule from './user'

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  // If Vuex state is mutated outside of mutation handlers, an error will be thrown
  // Turn it off in production to avoid the performance cost
  strict: process.env.NODE_ENV !== 'production',
  state: {
    schema: null,
    err: false
  },
  getters: {
    database: (state, getters) => ({
      host: `${process.env.VUE_APP_DATABASE_PROTOCOL}://${process.env.VUE_APP_DATABASE_HOST}:${process.env.VUE_APP_DATABASE_PORT}/${process.env.VUE_APP_DATABASE_FOLDER}`,
      username: process.env.VUE_APP_DATABASE_USER,
      password: process.env.VUE_APP_DATABASE_PASSWORD,
      schema: process.env.VUE_APP_DATABASE_SCHEMA,
      // Ideally we don't store anything at schema level, but defaults for clarity
      opts: { keyEncoding: 'utf8', valueEncoding: 'utf8' }
    }),
    isConnected: (state, getters) => (state.schema !== null),
    hasConnectionError: (state, getters) => (state.err !== false)
  },
  mutations: {
    CONNECT: (state, schema) => {
      state.schema = schema
    },
    DISCONNECT: (state) => {
      state.schema = false
    },
    CONNECTION_ERR: (state, err) => {
      state.err = err
    }
  },
  actions: {
    async init ({ state, rootState, commit, dispatch, getters, rootGetters }) {
      if (getters.isConnected) return

      let settings = getters.database
      let db = multilevel2(settings.host, { username: settings.username, password: settings.password })
      let schema = sublevel.sub(db, settings.schema, settings.opts)

      // Some sort of ping/pong to ensure connection
      let chance = new Chance()
      let ping = 'ping-' + chance.word()
      let pong = 'pong-' + chance.android_id()

      try {
        await schema.put(ping, pong)
        let reply = await schema.get(ping)
        if (reply !== pong) throw new ApplicationException('Cannot verify connection')

        commit('CONNECT', schema)
        commit('CONNECTION_ERR', false)
      } catch (e) {
        commit('CONNECTION_ERR', e.message)
        commit('DISCONNECT')
        throw e
      } finally {
        // Remove any temporary pings
        if (getters.isConnected) await schema.del(ping)
      }
    }
  },
  modules: {
    user: UserModule
  }
})

export default store
